import React, { useState, useEffect } from "react";
import { getToken } from "../../utils/token";
import "./style.css";
import HomeBg from "../../assets/images/homebg.png";
const TopNav = () => {
  const [username, setUsername] = useState("");
  useEffect(() => {
    (async () => {
      try {
        let username = await getToken("spiral_user");
        setUsername(username);
      } catch (err) {
        console.log(err);
      }
    })();
    return () => {};
  }, []);

  return (
    <div className="nav px-3 bg-white d-flex align-items-center justify-content-between w-100 ">
      <div className="upply-name pt-2 d-flex align-items-center">
        <h6>Hello {username}</h6>
      </div>
      <div className="nav-right d-flex align-items-center">
        <div className="upgrade-cover p-2 rounded-3 d-flex align-items-center">
          <div className="upgrade-icon d-flex align-items-center justify-content-center mx-2">
            {/* <ion-icon name="star"></ion-icon> */}
          </div>
          {/* <div>Upgrade your plan</div> */}
        </div>
        <div className="noti-icon px-2 mx-3 d-flex align-items-center justify-content-center ">
          {/* <ion-icon name="notifications-outline" className="notify-icon"></ion-icon> */}
        </div>
        <div className="profile-icon  shadow-sm">
          <img
            src={
              "https://images.unsplash.com/photo-1576158113928-4c240eaaf360?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YWRtaW4lMjBpbWFnZXxlbnwwfHwwfHx8MA%3D%3D"
            }
            className={"image-fluid"}
            width={"100%"}
            height={"100%"}
          />
        </div>
      </div>
    </div>
  );
};

export default TopNav;
